import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchSearchResultGadgetDetail } from 'api/search-result.service';
import { SearchResultResponse } from 'types/entity';

export const SEARCH_RESULT_GADGET_READ_NAME = 'searchResultGadgetRead';

export const loadSearchResultGadgetDetail = createAsyncThunk(
  `${SEARCH_RESULT_GADGET_READ_NAME}/load`,
  async (arg: {selectedProjectId: string, searchCriteriaId: string}, thunkAPI) => {
    const response = await fetchSearchResultGadgetDetail(arg.selectedProjectId, arg.searchCriteriaId);
    return response;
  },
);

export interface SearchResultGadgetReadState {
  loaded: boolean
  entities: { [searchCriteriaId: string]: SearchResultResponse[] | undefined }
  error: any
}

export const initialSearchResultGadgetReadState: SearchResultGadgetReadState = {
  loaded: false,
  entities: {},
  error: null,
};

export const searchResultGadgetReadSlice = createSlice({
  name: SEARCH_RESULT_GADGET_READ_NAME,
  initialState: initialSearchResultGadgetReadState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadSearchResultGadgetDetail.pending, (state, action) => {
      state.entities = { ...state.entities, [action.meta.arg.searchCriteriaId]: undefined };
      state.loaded = false;
    });
    builder.addCase(loadSearchResultGadgetDetail.fulfilled, (state, action) => {
      state.entities = { ...state.entities, ...action.payload };
      state.loaded = true;
    });
    builder.addCase(loadSearchResultGadgetDetail.rejected, (state, action) => {
      state.error = action.payload;
      state.loaded = true;
    });
  },
});

export const searchResultGadgetReadAction = {
  ...searchResultGadgetReadSlice.actions,
  loadSearchResultGadgetDetail,
};

export default searchResultGadgetReadSlice.reducer;
